export default{
  copyToEdit: {
    copy_id: null,
    copy_name: '',
    product: {
      product_id: null,
      product_name: '',
      product_owner_name: '',
      product_is_active: null,
      product_updated_at: ''
    },
    copy_is_active: true,
    copy_updated_at: ''
  },
  loading: true,
  page: 0,
  size: 200,
  pagination: {
    current_page: 0,
    number_of_elements: 0,
    total_elements: 0,
    total_pages: 0
  },
  is_active: null,
  product_id: '',
  items: []
}


// WEBPACK FOOTER //
// ./src/store/modules/copy/state.js